import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { BASE_URL, HTTP_STATUS } from '../../utils/constant'
import { newAxiosInstance } from '../../../axios'

const initialState = {
    duties: [],
    status: HTTP_STATUS.IDLE,
    deleteStatus: HTTP_STATUS.IDLE
}

export const fetchAttendanceDuties = createAsyncThunk('attendanceDuty/fetch', async (_, { rejectWithValue }) => {
    try {
        const response = await newAxiosInstance.get(`${BASE_URL}/api/AttendanceDuty`)
        return response.data
    } catch (err) {
        if (!err.response) throw err;
        return rejectWithValue(err.response.data)
    }
})

export const createAttendanceDuty = createAsyncThunk('attendanceDuty/create', async (postdata, { rejectWithValue }) => {
    try {
        const response = await newAxiosInstance.post(`${BASE_URL}/api/AttendanceDuty`, postdata)
        return response.data
    } catch (err) {
        if (!err.response) throw err;
        return rejectWithValue(err.response)
    }
})

export const updateAttendanceDuty = createAsyncThunk('attendanceDuty/update', async (postdata, { rejectWithValue }) => {
    try {
        const response = await newAxiosInstance.put(`${BASE_URL}/api/AttendanceDuty/${postdata.id}`, postdata)
        return response.data
    } catch (err) {
        if (!err.response) throw err;
        return rejectWithValue(err.response)
    }
})

export const deleteAttendanceDuty = createAsyncThunk('attendanceDuty/delete', async (id, { rejectWithValue }) => {
    try {
        const response = await newAxiosInstance.delete(`${BASE_URL}/api/AttendanceDuty/${id}`)
        return response.data
    } catch (err) {
        if (!err.response) throw err;
        return rejectWithValue(err.response.data)
    }
})

const AttendanceDutySlice = createSlice({
    name: 'attendanceDuty',
    initialState,
    reducers: {
        resetState: (state, action) => {
            return initialState;
        }
    },
    extraReducers(builder) {
        builder
            .addCase(fetchAttendanceDuties.pending, (state) => {
                state.status = HTTP_STATUS.LOADING
            })
            .addCase(fetchAttendanceDuties.fulfilled, (state, action) => {
                state.status = HTTP_STATUS.SUCCEEDED
                state.duties = action.payload
            })
            .addCase(fetchAttendanceDuties.rejected, (state) => {
                state.status = HTTP_STATUS.FAILED
            })
            .addCase(deleteAttendanceDuty.pending, (state) => {
                state.deleteStatus = HTTP_STATUS.LOADING
            })
            .addCase(deleteAttendanceDuty.fulfilled, (state) => {
                state.deleteStatus = HTTP_STATUS.SUCCEEDED
            })
            .addCase(deleteAttendanceDuty.rejected, (state) => {
                state.deleteStatus = HTTP_STATUS.FAILED
            })
    }
})

export const getAttendanceDuties = (state) => state.attendanceDuty.duties;
export const getAttendanceDutyStatus = (state) => state.attendanceDuty.status;
export const getAttendanceDutyDeleteStatus = (state) => state.attendanceDuty.deleteStatus;

export const attendanceDutyActions = AttendanceDutySlice.actions

export default AttendanceDutySlice.reducer
